/**
 *
 * @module entry
 * @desc {SDK.Internal.Dust} entry point.
 *
 */

import DustSink from './dustSink';
import DustEvent from './dustEvent';

/**
 *
 * @typedef SDK.Internal.Dust
 * @type {Object}
 *
 * @property {DustSink} DustSink
 * @property {DustEvent} DustEvent
 *
 */

/**
 *
 * @type {SDK.Internal.Dust}
 *
 */
export default {

    DustSink,
    DustEvent

};



// WEBPACK FOOTER //
// ./src/internal/dust/entry.js